import EditRoleInline from "components/Actions/dialogs/Roles/Inline/EditRole";
import EditUserInline from "components/Actions/dialogs/Users/Inline/EditUser";
import ResendInvitation from "components/Actions/dialogs/Users/Inline/ResendInvitation";
import {
    useRoleInlineActions,
    useUserInlineActions
} from "components/Actions/InlineActions";
import { USER_ACTIONS } from "components/Actions/types";
import MainContainer from "components/MainContainer";
import Table, { TabFilters } from "components/Table";
import {
    ENDPOINTS,
    FILTER_NAMES,
    ID_TYPE,
    ROLE_AND_PERMISSION_COLUMNS,
    ROUTES,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions,
    USER_COLUMNS,
    useWindowLocation
} from "shared";

const Users = () => {
    const { isReadUserNotAllowed, isReadRoleNotAllowed } = usePermissions();

    const {
        isUserEditOpen,
        isInvitationResendOpen,
        userInlineActions,
        userRowData,
        closeDialog
    } = useUserInlineActions();

    const { isRoleOpen, roleInlineActions, roleRowData, closeEditRoleDialog } =
        useRoleInlineActions();

    const { pathname } = useWindowLocation();

    const getActiveTable = () =>
        pathname === ROUTES.Users ? TABLE_NAMES.Users : TABLE_NAMES.Roles;

    const data = {
        [TABLE_NAMES.Users]: {
            testId: "users-table",
            columns: USER_COLUMNS,
            nameForFilters: TABLE_NAMES_WITH_FILTERS.Users,
            inlineActions: userInlineActions,
            hasNoPermission: isReadUserNotAllowed,
            route: ROUTES.Users,
            customResource: undefined
        },
        [TABLE_NAMES.Roles]: {
            testId: "roles-and-permissions-table",
            columns: ROLE_AND_PERMISSION_COLUMNS,
            nameForFilters: TABLE_NAMES_WITH_FILTERS.Roles,
            inlineActions: roleInlineActions,
            hasNoPermission: isReadRoleNotAllowed,
            route: ROUTES.Roles,
            customResource: `${ENDPOINTS.Roles}?${FILTER_NAMES.IncludeStatic}=true`
        }
    };

    const tabs = Object.entries(data).map(([tableName, data]) => ({
        label: tableName as TABLE_NAMES,
        route: data.route
    }));

    const activeTable = getActiveTable();

    const hasNoPermission = data[activeTable].hasNoPermission;
    const testId = data[activeTable].testId;
    const nameForFilters = data[activeTable].nameForFilters;
    const initialColumns = data[activeTable].columns;
    const inlineActions = data[activeTable].inlineActions;
    const customResource = data[activeTable].customResource;

    const isUsersTable = activeTable === TABLE_NAMES.Users;
    const isRolesTable = activeTable === TABLE_NAMES.Roles;

    return (
        <>
            <MainContainer>
                <Table
                    data-testid={testId}
                    key={activeTable}
                    name={activeTable}
                    nameForFilters={nameForFilters}
                    customResource={customResource}
                    hasNoPermissionToRead={hasNoPermission}
                    initialColumns={initialColumns}
                    inlineActions={inlineActions}
                    idType={ID_TYPE.Id}
                    sortFromNewest
                    hasActionBar
                    hasDetails={isUsersTable}
                    tabFilters={<TabFilters tableName={pathname} tabs={tabs} />}
                />
            </MainContainer>

            {isUsersTable && (
                <>
                    <EditUserInline
                        data={userRowData}
                        isOpen={isUserEditOpen}
                        close={() => closeDialog(USER_ACTIONS.EditUser)}
                    />

                    <ResendInvitation
                        data={userRowData}
                        isOpen={isInvitationResendOpen}
                        close={() => closeDialog(USER_ACTIONS.ResendInvitation)}
                    />
                </>
            )}

            {isRolesTable && (
                <EditRoleInline
                    data={roleRowData}
                    isOpen={isRoleOpen}
                    close={closeEditRoleDialog}
                />
            )}
        </>
    );
};

export default Users;
